module.exports = {
  API: 'API',
  APP: 'APP',
  SPREADSHEET: 'SPREADSHEET'
};
